export const defaultItems = []
export const defaultPage = 1
export const defaultLoading = false
export const defaultFilter = null
export const defaultHasMorePages = true
export const defaultCompanyId = null

export default {
  items: defaultItems,
  page: defaultPage,
  loading: defaultLoading,
  filter: defaultFilter,
  hasMorePages: defaultHasMorePages,
  companyId: defaultCompanyId
}
